/**

Coded by www.techhighway.ca

*/

/**
  This file is used for controlling the global states of the components,
  you can customize the states for the different components here.
*/

import { createContext, useState } from "react";

// Preserve Table Search, Sort and Entries per page Context
export const PreserveTable = createContext({
  status: {},
  parameter: {},
  user: {},
  permission: {},
  agent: {},
  call: {},
  client: {},
  setPreserveStatus: () => {},
  setPreserveParameter: () => {},
  setPreserveUser: () => {},
  setPreservePermission: () => {},
  setPreserveAgent: () => {},
  setPreserveCall: () => {},
  setPreserveClient: () => {},
  reset: () => {},
});

function PreserveTableProvider({ children }) {
  const [status, setStatus] = useState({
    page_no: 1,
    page_size: 10,
    sort_column: "name",
    sort_column_value: "asc",
    search_value: "",
  });
  const [parameter, setParameter] = useState({
    page_no: 1,
    page_size: 10,
    sort_column: "id",
    sort_column_value: "desc",
    search_value: "",
  });
  const [user, setUser] = useState({
    page_no: 1,
    page_size: 10,
    sort_column: "first_name",
    sort_column_value: "asc",
    search_value: "",
  });
  const [permission, setPermission] = useState({
    page_no: 1,
    page_size: 10,
    sort_column: "id",
    sort_column_value: "desc",
    search_value: "",
  });
  const [agent, setAgent] = useState({
    page_no: 1,
    page_size: 10,
    sort_column: "id",
    sort_column_value: "desc",
    search_value: "",
  });
  const [call, setCall] = useState({
    page_no: 1,
    page_size: 10,
    sort_column: "id",
    sort_column_value: "desc",
    search_value: "",
  });
  const [client, setClient] = useState({
    page_no: 1,
    page_size: 10,
    sort_column: "name",
    sort_column_value: "asc",
    search_value: "",
  });

  const setPreserveStatus = async (status) => {
    setStatus(status);
  };
  const setPreserveParameter = async (parameter) => {
    setParameter(parameter);
  };
  const setPreserveUser = async (user) => {
    setUser(user);
  };
  const setPreservePermission = async (permission) => {
    setPermission(permission);
  };
  const setPreserveCall = async (call) => {
    setCall(call);
  };
  const setPreserveAgent = async (agent) => {
    setAgent(agent);
  };
  const setPreserveClient = async (client) => {
    setClient(client);
  };

  const reset = () => {
    setPreserveStatus({
      page_no: 1,
      page_size: 10,
      sort_column: "id",
      sort_column_value: "asc",
      search_value: "",
    });
    setPreserveParameter({
      page_no: 1,
      page_size: 10,
      sort_column: "id",
      sort_column_value: "desc",
      search_value: "",
    });
    setPreserveUser({
      page_no: 1,
      page_size: 10,
      sort_column: "id",
      sort_column_value: "asc",
      search_value: "",
    });
    setPreservePermission({
      page_no: 1,
      page_size: 10,
      sort_column: "id",
      sort_column_value: "desc",
      search_value: "",
    });
    setPreserveAgent({
      page_no: 1,
      page_size: 10,
      sort_column: "id",
      sort_column_value: "desc",
      search_value: "",
    });
    setPreserveCall({
      page_no: 1,
      page_size: 10,
      sort_column: "id",
      sort_column_value: "desc",
      search_value: "",
    });
    setPreserveClient({
      page_no: 1,
      page_size: 10,
      sort_column: "id",
      sort_column_value: "desc",
      search_value: "",
    });
  };

  return (
    <PreserveTable.Provider
      value={{
        status,
        parameter,
        user,
        permission,
        agent,
        call,
        client,
        setPreserveStatus,
        setPreserveParameter,
        setPreserveUser,
        setPreservePermission,
        setPreserveAgent,
        setPreserveCall,
        setPreserveClient,
        reset,
      }}
    >
      {children}
    </PreserveTable.Provider>
  );
}

export { PreserveTableProvider };
